import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { formatItemDate } from "../../helpers/";
import ObjectiveActivities from "./ObjectiveActivities";

const Div = styled.div`
                    padding: 10px 0;

                    h2{
                        font-size:18px;
                        color:#000;
                        text-align:center;
                        padding-top:8px;
                        font-weight:bold;
                    }
                    .col-fifth{
                        position: relative;
                        width: 100%;
                        padding-right: 15px;
                        padding-left: 15px;
                        flex: 0 0 20%;
                        max-width: 20%;
                    }

`;

const ObjectiveBox = styled.div`
                     width:100%;
                     background: #fff;
                     color:#999999;
                     text-align:center;
                     border-radius:10px;
                     span{
                        font-weight:bold;
                        font-size:15px;
                     }
                     .content{
                        padding: 8px 8px;
                        min-height:80px;
                        p{
                            font-size:13px;
                            line-height:13px;
                            margin-bottom:0px;
                        }
                     }
                     .title{
                         background: #C30019;
                         color: #fff;
                         font-size:12px;
                         padding:8px;
                         font-weight:bold;import { Link } from "react-router-dom";
                         min-height:60px;
                         border-radius:10px;
                         .title-link{
                             display:block;
                             width:100%;
                             height:100%;
                         }
                         .icon{
                             width:10%;
                             float:left;
                             line-height:30px;
                         }
                         .title-text{
                             width:90%;
                             float:left;
                         }
                     }
                     .user{
                        display:inline-block;
                     }
                     .user-name{
                        background: #e5f3fe;
                        width: 40px;
                        height: 40px;
                        margin: auto;
                        line-height: 40px;
                        border-radius: 50%;
                        color: #0184fe;
                        display: inline-block;
                     }
                     .date{
                        padding-top:8px;
                        .date-left, .date-right{
                             padding:8px;
                             width:50%;
                             float:left;
                             font-size:12px;
                             text-align:left;
                        }
                        .objective-due{
                            color:#555;
                            font-size:11px;
                            line-height:12px;
                            font-weight:normal;
                        }
                        .clear{
                             clear:both;
                        }
                     }
                     .status-outer{
                         padding:8px;
                         display:inline-block;
                         position:relative;
                     }
                     .status {
                        width: 20px;
                        height: 20px;
                        border-radius: 20px;
                        position:absolute;
                        top:0px;
                    }
                    .center{
                        width:100%;
                    }
                    .center-left{
                        float:left;
                        width:50%;
                    }
                    .center-right{
                        float:left;
                        width:50%;
                    }
`;


function ObjectiveBoxMobile(props) {
    const [showContent, setShowContent] = useState(0);
    const [show, setShow] = useState(false);
    const [showActivities, setShowActivities] = useState(false);

    const handleClose = () => setShow(false);
    const handleActivitiesClose = () => setShowActivities(false);

    let item = props.item;

    const handleShow = function (event) {
        event.preventDefault();
        setShow(true);
    };

    const handleActivitiesShow = function (event) {
        event.preventDefault();
        setShowActivities(true);
    };


    const setStatus = (event) => {
        event.preventDefault();
        setShowContent(showContent === true ? false : true);
    }

    return (
        <Div>
            <ObjectiveBox>
                <div className="title">
                    <a href="/" className="title-link" onClick={setStatus}>
                        <span className="icon">
                            <FontAwesomeIcon icon={faArrowCircleRight} />
                        </span>
                        <span className="title-text">
                            {item.name}
                        </span>
                    </a>
                </div>
                {showContent ?
                    <div className="objective-mobile-main">
                        <div className="content">
                            <p>{props.item.description}
                            </p>
                        </div>

                        <div className="center">
                            <div className="center-left">
                                <div className="user">
                                    <span className="user-name">{props.item.users[0].name.charAt(0) + props.item.users[0].surname.charAt(0)}</span>
                                </div>
                                <div className="status-outer">
                                    <div className={`status ${props.item.status}`}></div>
                                </div>
                            </div>
                            <div className="center-right">
                                <a href="#" className="info-icon" onClick={handleActivitiesShow} >
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                </a>
                            </div>
                            <div className="clear"></div>
                        </div>
                        <div className="date">
                            <div className="date-left">Start date <br /><span className="objective-due">{formatItemDate(props.item.start)}</span></div>
                            <div className="date-right">Due date  <br /><span className="objective-due">{formatItemDate(props.item.finish)}</span></div>
                            <div className="clear"></div>
                        </div>
                    </div>
                    : ''}
            </ObjectiveBox>
            <ObjectiveActivities show={showActivities} onHide={handleActivitiesClose} item={props.item} />
        </Div>
    );
}

export default ObjectiveBoxMobile;